interface ToggleCellProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel: string;
}

export function ToggleCell({
  checked,
  onChange,
  disabled = false,
  ariaLabel,
}: ToggleCellProps) {
  return (
    <td className="size-px whitespace-nowrap px-4 py-1">
      <label className="relative inline-flex cursor-pointer items-center">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          disabled={disabled}
          className="peer sr-only"
          aria-label={ariaLabel}
        />
        <div
          className={`
            h-5 w-9 rounded-full bg-surface-darker
            after:absolute after:start-[2px] after:top-[2px]
            after:h-4 after:w-4 after:rounded-full after:bg-white
            after:transition-all after:content-['']
            peer-checked:bg-primary peer-checked:after:translate-x-full
            peer-focus:ring-2 peer-focus:ring-primary/20
            peer-disabled:cursor-not-allowed peer-disabled:opacity-50
          `}
        />
      </label>
    </td>
  );
}
